<template>
  <div>
    <app-nav :full-name="userFullName" />

    <div class="columns">
      <div class="column"/>
      <div class="column is-three-quarters">

        <section>
          <h1 class="title">Article Information</h1>
        </section>
        <!-- article form, should be populated with data if existing factory -->

        <form @submit.prevent="saveArticle">
          <div class="columns">
            <div class="column is-half">
              <b-field label="Factory">
                <b-select
                  v-model="factoryCode"
                  :disabled="factoryCodeSelectDisabled"
                  placeholder="Select a factory"
                  required>
                  <option
                    v-for="f in factories"
                    :value="f.factoryCode"
                    :key="f.factoryCode">
                    {{ f.factoryCode }} - {{ f.factoryName }}
                  </option>
                </b-select>
              </b-field>

              <b-field label="Factory Number">
                <b-input
                  v-model="factoryNumber"
                  name="factoryNumber"
                  placeholder="T-14939" />
              </b-field>

              <b-field label="Factory Content">
                <b-input
                  v-model="factoryContent"
                  name="factoryContent"
                  placeholder="TC 74/36" />
              </b-field>

              <b-field label="Factory Spec">
                <b-input
                  v-model="factorySpec"
                  name="factorySpec"
                  placeholder="100D*40S+300D" />
              </b-field>

              <b-field label="Factory Width">
                <b-input
                  v-model="factoryWidth"
                  name="factoryWidth"
                  placeholder="57/58''" />
              </b-field>

              <b-field label="Factory Weight">
                <b-input
                  v-model="factoryWeight"
                  name="factoryWeight"
                  placeholder="180GSM" />
              </b-field>

              <b-field label="Factory Price">
                <b-input
                  v-model="factoryPrice"
                  name="factoryPrice"
                  placeholder="3.50" />
              </b-field>

              <b-field label="Factory Price Date">
                <b-input
                  v-model="factoryPriceDate"
                  name="factoryPriceDate" />
              </b-field>

              <b-field label="Notes">
                <b-input
                  v-model="notes"
                  type="textarea"
                  name="notes"
                  placeholder="Some notes about this article ..." />
              </b-field>

              <div class="field is-grouped article-buttons">
                <div class="control">
                  <button
                    class="button is-link">Save</button>
                </div>
                <div
                  v-if="printLinkEnabled"
                  class="control">
                  <a
                    :href="'https://api-apollo.tianenusa.com/articles/' + articleId + '/print'"
                    class="button is-success"
                    target="_blank">Print</a>
                </div>
                <div class="control">
                  <router-link
                    class="button is-danger is-outlined"
                    to="/articles">Cancel</router-link>
                </div>
              </div>

            </div>
            <div class="column is-half">

              <div class="field">
                <b-switch v-model="copyFromFactory">
                  <!-- <b-tag size="is-medium">Copy From Factory</b-tag> -->
                  Copy From Factory
                  <b-tooltip
                    label="Any empty field below will be copied from Factory information">
                    <b-icon
                      icon="help-circle"
                      size="is-small" />
                  </b-tooltip>

                </b-switch>
              </div>

              <b-field
                v-if="article.articleId !== undefined && article.articleId !== ''"
                label="System ID">
                <b-input
                  v-model="articleId"
                  name="articleId"
                  disabled />
              </b-field>

              <b-field
                v-if="article.articleId !== undefined && article.articleId !== ''"
                label="Article ID">
                <b-input
                  :value="'TE-' + article.factoryCode + '-' + article.articleId"
                  disabled />
              </b-field>

              <b-field label="Content">
                <b-input
                  v-model="content"
                  :disabled="ourInputDisabled"
                  name="content" />
              </b-field>

              <b-field label="Spec">
                <b-input
                  v-model="spec"
                  :disabled="ourInputDisabled"
                  name="spec" />
              </b-field>

              <b-field label="Width">
                <b-input
                  v-model="width"
                  :disabled="ourInputDisabled"
                  name="width" />
              </b-field>

              <b-field label="Weight">
                <b-input
                  v-model="weight"
                  :disabled="ourInputDisabled"
                  name="weight" />
              </b-field>

              <b-field label="Price">
                <b-input
                  v-model="price"
                  :disabled="ourInputDisabled"
                  name="price" />
              </b-field>

              <b-field label="Price Date">
                <b-input
                  v-model="priceDate"
                  :disabled="ourInputDisabled"
                  name="priceDate" />
              </b-field>

              <b-field>
                <b-collapse
                  :open="internalNotesOpen"
                  class="card">
                  <div
                    slot="trigger"
                    slot-scope="props"
                    class="card-header">
                    <p class="card-header-title">
                      <b-icon icon="lock" />
                      <span class="internal-notes-title">Internal Notes</span>
                    </p>
                    <a class="card-header-icon">
                      <b-icon :icon="props.open ? 'menu-down' : 'menu-up'" />
                    </a>
                  </div>
                  <div class="card-content">
                    <div class="content">
                      <b-input
                        v-model="internalNotes"
                        type="textarea"
                        name="internalNotes"
                        placeholder="Private notes about this article ..." />
                    </div>
                  </div>
                </b-collapse>
              </b-field>

            </div>

          </div>

        </form>

      </div>
      <div class="column"/>
    </div>

    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="true" />
  </div>
</template>

<script>
import AppNav from './AppNav'
import { checkLogin, getUser } from '../utils/auth'
import { getArticle, saveArticle, getFactoriesOverview } from '../utils/api'

export default {
  name: 'articles',
  components: {
    AppNav
  },
  data() {
    return {
      article: {},
      factories: [],
      factoryCodeSelectDisabled: false,
      printLinkEnabled: false,
      internalNotesOpen: false,
      // navbar
      userFullName: '',
      // loading
      isLoading: false,
      // input values
      articleId: '',
      content: '',
      spec: '',
      width: '',
      weight: '',
      price: '',
      priceDate: '',
      notes: '',
      internalNotes: '',
      factoryCode: '',
      factoryNumber: '',
      factoryContent: '',
      factorySpec: '',
      factoryWidth: '',
      factoryWeight: '',
      factoryPrice: '',
      factoryPriceDate: new Date().toLocaleDateString(),
      copyFromFactory: true
    }
  },
  computed: {
    ourInputDisabled: function() {
      return this.copyFromFactory
    }
  },
  mounted() {
    let self = this
    checkLogin().then(function(loggedIn) {
      if (loggedIn) {
        self.getArticle()
        self.userFullName = JSON.parse(getUser()).fullName
      } else {
        self.$router.push('/login')
      }
    })
  },
  methods: {
    getArticle() {
      let self = this
      if (this.$route.params.articleId !== undefined) {
        self.isLoading = true
        let articleId = this.$route.params.articleId
        getArticle(articleId).then((article) => {
          self.article = article
          // populate input values
          self.articleId = self.article.articleId
          self.content = self.article.content
          self.spec = self.article.spec
          self.width = self.article.width
          self.weight = self.article.weight
          self.price = self.article.price
          self.priceDate = self.article.priceDate
          self.notes = self.article.notes
          self.internalNotes = self.article.internalNotes
          self.factoryCode = self.article.factoryCode
          self.factoryNumber = self.article.factoryNumber
          self.factoryContent = self.article.factoryContent
          self.factorySpec = self.article.factorySpec
          self.factoryWidth = self.article.factoryWidth
          self.factoryWeight = self.article.factoryWeight
          self.factoryPrice = self.article.factoryPrice
          self.factoryPriceDate = self.article.factoryPriceDate
          // change disabled properties
          self.factoryCodeSelectDisabled = true
          self.printLinkEnabled = true
        }).catch(function() {
          self.$toast.open({
            message: 'Failed to get article information.',
            duration: 3000,
            position: 'is-top',
            type: 'is-danger'
          })
        }).finally(function() {
          self.isLoading = false
        })
      }
      getFactoriesOverview().then(fs => {
        self.factories = fs
      })
    },
    saveArticle() {
      let article = {
        articleId: this.articleId,
        factoryCode: this.factoryCode,
        factoryNumber: this.factoryNumber,
        factoryContent: this.factoryContent,
        factorySpec: this.factorySpec,
        factoryWidth: this.factoryWidth,
        factoryWeight: this.factoryWeight,
        factoryPrice: this.factoryPrice,
        factoryPriceDate: this.factoryPriceDate,
        notes: this.notes,
        internalNotes: this.internalNotes,
        content: this.content,
        spec: this.spec,
        width: this.width,
        weight: this.weight,
        price: this.price,
        priceDate: this.priceDate
      }
      let self = this
      let existingArticle = (self.article !== undefined && self.article.articleId !== undefined && self.article.articleId !== '')
      saveArticle(article, existingArticle)
        .then(function(response) {
          self.$toast.open({
            message: 'Article was saved successfully.',
            duration: 5000,
            position: 'is-top',
            type: 'is-success'
          })
          let newId = response.data
          self.$router.push(`/articles/${newId}`)
        })
        .catch(function(error) {
          console.log(error)
          self.$toast.open({
            message: 'Failed to save article in database.',
            duration: 5000,
            position: 'is-top',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
section .title {
  margin-bottom: 20px;
}
.article-buttons {
  margin-top: 20px;
}
.internal-notes-title {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Article.vue